// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"b3c8c2ca","601":"5470f3c6","787":"7723db46"}[chunkId] + ".chunk.js";
};